// src/com/trans_plan_result/TransPlanResult.js
import React, { useState, useEffect, useRef } from 'react';
//import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TopContainer, TopHeader, TopContent, ControlLine, NoDataBox } from '../../common/TopStyle';
import { LIST_TRANS_PLAN_RESULT_FOR_RENT, REPORT_TRANS_PLAN_RESULT_IN_OUT } from './TransPlanResultGql';
import { AppObject, AppStyle, TopCode } from '../../value/AppConst';
import { transPlanResultListForRentRepo } from '../../value/AppModel';
import { useAlertSetter } from '../../api/app-hook';
import { useSnackbar } from 'notistack';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import SearchBox from '../../common/SearchBox';
import IsValid from '../../value/IsValid';
import TransPlanResultView from './TransPlanResultView';
import TransPlanResultLine from './TransPlanResultLine';

/**
 * 용차시간관리
 * @returns 
 */
export default function TransPlanResult() {
    const [searchText, setSearchText] = useState('');
    const [itemSelected, setItemSelected] = useState({});
    const [records, setRecords] = useState([]);
    const [sortInfo, setSortInfo] = useState({id: null, order: 0}); // -1 : descending, 0: no sorting, 1: ascending
    const transPlanResultListData = useReactiveVar(transPlanResultListForRentRepo);
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const reportDcOutRef = useRef(false); // true-센터출발, false-점포도착.
    const runRef = useRef(false);

    // ##### Call GraphQL to get List #####
    const [getTransPlanResultListForRent, responseListForRent] = useLazyQuery(LIST_TRANS_PLAN_RESULT_FOR_RENT, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetListForRent(data, option)},
		onError: (error) => addAlert({title: "용차 배차결과 조회 오류", message: [error.message]})
    });
    const [reportTransPlanResultInOut, responseReport] = useMutation( REPORT_TRANS_PLAN_RESULT_IN_OUT, {
		onCompleted: (data, option) => onCompleteReportInOut(data, option), 
		onError: (error) => addAlert({title: "출발, 도착 시간 설정 오류", message: [error.message]})
	} );

    useEffect(() => {
        if(!runRef.current) {
            runRef.current = true;
            const diff = new Date().getTime()/1000 - transPlanResultListData.when;
            if(diff > 300) //  || transPlanResultListData.records.length === 0 - Don't use this condition
                getTransPlanResultListForRent();
        }
    }, []);
        
    useEffect(() => {
        let list;
        const txt = searchText ? searchText.trim().toLowerCase() : '';
        if(IsValid.nullString(txt)) list = transPlanResultListData.records;
        else {
            list = transPlanResultListData.records.filter((item) => {
                return (
                    item.dcName.toLowerCase().includes(txt) ||
                    (item.storeName && item.storeName.toLowerCase().includes(txt)) ||
                    (item.vehPlates && item.vehPlates.toLowerCase().includes(txt))
                );
            })
        }

        if(sortInfo.id && sortInfo.order !== 0) {
            const newList = [...list].sort((a, b) => {
                const orderBy = sortInfo.order < 0 ? -1 : 1; // -1: descending, 1: ascending
                if(a[sortInfo.id] < b[sortInfo.id]) return -1 * orderBy;
                if(a[sortInfo.id] > b[sortInfo.id]) return orderBy;
                return 0;
            });
            list = newList;
        }

        setRecords(list);
    }, [searchText, transPlanResultListData, sortInfo]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetListForRent = (data, clientOption) => {
        if(data.transPlanResultListForRent) {
            transPlanResultListForRentRepo({when:new Date().getTime()/1000, records:data.transPlanResultListForRent});
            setItemSelected({}); // Reset selected item
        }
    };

    const onCompleteReportInOut = (data, clientOption) => {
        if(data.transPlanResultRportInOut.ok) {
            enqueueSnackbar(reportDcOutRef.current ? "센터 출발 보고 완료" : "점포 도착 보고 완료", {
                variant: AppStyle.mui.success, autoHideDuration: 1500
            });
            getTransPlanResultListForRent();
        }
        else addAlert({title:"출발, 도착 시간 설정 오류", message:[data.transPlanResultRportInOut.message]});
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onRequestReportInOut = (param) => {
        reportDcOutRef.current = param.eventId === TopCode.IrAction.DC_DEP;
        reportTransPlanResultInOut({variables: {transPlanResult: param}});
    };

    const onClickSorter = (id, sortState) => {
        setSortInfo({id, order: sortState});
    };

    const loadingAny = responseListForRent.loading || responseReport.loading;

    return(
        <TopContainer>
            <TopHeader>
                용차시간관리
            </TopHeader>
            <ControlLine>
                <SearchBox
                    value={searchText}
                    onChangeText={onChangeSearchText}
                    disabled={responseListForRent.loading}
                />
            </ControlLine>
            <TransPlanResultLine
                onClickSorter={onClickSorter}
                idSorted={sortInfo.id}
            />
            <TopContent>
                {
                    records.length === 0 ?
                    <NoDataBox />
                    :
                    <Box>
                        {
                            records.map((item, index) => {
                                if(item.planId === itemSelected.planId) {
                                    return (
                                        <TransPlanResultView
                                            key={index}
                                            item={item}
                                            onClose={() => setItemSelected({})}
                                            onRequestReportInOut={onRequestReportInOut}
                                            loading={loadingAny}
                                        />
                                    )
                                }
                                return (
                                    <TransPlanResultLine
                                        key={index}
                                        item={item}
                                        index={index}
                                        itemSelected={itemSelected}
                                        onClick={(item) => {setItemSelected(item)}}
                                    />
                                )
                            })
                        }
                    </Box>
                }
            </TopContent>
        </TopContainer>
    );
}
